import { useTranslation } from 'react-i18next';

const AboutHero = () => {
  const { t } = useTranslation();
  
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-[#050008] pt-20">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0d0020] via-[#050008] to-[#000d1a]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_50%,rgba(140,82,255,0.2)_0%,transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_50%,rgba(0,194,255,0.1)_0%,transparent_60%)]" />
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: 'linear-gradient(rgba(140,82,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(140,82,255,0.5) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center py-20">
        <div className="inline-flex items-center gap-2 bg-white/5 border border-[#8c52ff]/30 rounded-full px-4 py-2 mb-6">
          <i className="ri-user-heart-line text-[#8c52ff] text-sm" />
          <span className="text-[#8c52ff] text-xs font-bold uppercase tracking-widest">{t('about.hero.badge')}</span>
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
          {t('about.hero.titlePrefix')}<span className="bg-gradient-to-r from-[#8c52ff] to-[#00c2ff] bg-clip-text text-transparent">{t('about.hero.titleHighlight')}</span>
        </h1>
        <p className="text-white/60 text-base md:text-xl leading-relaxed max-w-2xl mx-auto">
          {t('about.hero.subtitle')}
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
